import { Node_Type } from "./../ricos-types";
import {
  decorateComponentWithProps,
  INSERT_PLUGIN_BUTTONS,
  TOOLBARS
} from "./../editor-common";
import { DEFAULTS, gifModals } from "./constants";
import { InsertPluginIcon } from "./icons";
import InsertModal from "./modals/InsertModal";
const toolbarsToAddIn = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (config, _services) => {
  return [
    {
      id: Node_Type.GIF,
      label: INSERT_PLUGIN_BUTTONS.GIF,
      dataHook: INSERT_PLUGIN_BUTTONS.GIF,
      icon: InsertPluginIcon,
      tooltip: "GiphyPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: gifModals.insert,
        Component: decorateComponentWithProps(InsertModal, {
          componentData: DEFAULTS,
          modalId: gifModals.insert,
          getGiphyUrl: config == null ? void 0 : config.getGiphyUrl
        })
      },
      menuConfig: {
        tags: "Gif_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
